export const PT = {
  "Open document": "Abrir documento",
  "Upload file": "Subir arquivo",
  "Drop file here to upload": "Solte o arquivo aqui para fazer o upload",
  "Disc": "Disco",
  "URL": "URL",
  "FILE": "ARQUIVO",
  "SIZE": "TAMANHO",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "Carregando, por favor espere.",
  "Fit Width": "Largura de ajuste",
  "Fit Height": "Altura de ajuste",
  "Password protected document": "Documento protegido por senha",
  "Password": "Senha",
  "Open": "Abrir",
  "Password Required": "Senha requerida",
  "Incorrect password": "Senha incorreta",
  "Error": "Erro",
  "Something went wrong": "Algo deu errado",
  "Server is not available": "Servidor nÃ£o disponÃ­vel",
  "of": "do",
  "Please wait...": "Por favor, espere..."
};
